import { Helmet, HelmetProvider } from 'react-helmet-async';

export interface WistiaVideoPlayerProps {
    id: string;
    play?: boolean;
    style: React.CSSProperties;
}

export function WistiaVideoPlayer({ id, style }: WistiaVideoPlayerProps) {
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <script src={`https://fast.wistia.com/embed/medias/${id}.jsonp`} async />
                    <script src="https://fast.wistia.com/assets/external/E-v1.js" async />
                </Helmet>
            </HelmetProvider>
            <div
                className={`wistia_embed wistia_async_${id} videoFoam=true`}
                style={{ height: '100%', ...style }}
            />
        </>
    );
}
